export const ViewStates = {
    ANSWERING: "answering",
    SENDING: "sending",
    FINISHED: "finished",
    FAILED: "failed",
}
